import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const navigationLinks = [
  { label: "Dashboard", to: "/midwife" },
  { label: "Clients", to: "/midwife/clients" },
  { label: "Appointments", to: "/midwife/appointments" },
  { label: "Messages", to: "/midwife/messages" },
  { label: "Charts", to: "/midwife/charts" },
  { label: "Labs", to: "/midwife/labs" },
  { label: "Documents", to: "/midwife/documents" },
  { label: "Settings", to: "/midwife/settings" }
];

export default function Sidebar({ children }) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100 text-gray-900">
      {/* Mobile App Bar */}
      <div className="md:hidden flex justify-between items-center bg-emerald-700 text-white px-4 py-3">
        <h1 className="text-2xl font-bold">Vela</h1>
        <button 
          onClick={() => setSidebarOpen(!isSidebarOpen)}
          className="p-2 hover:bg-emerald-600 rounded-lg transition-colors"
          aria-label="Toggle menu"
        >
          ☰
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-gray-200 text-emerald-700
          p-6 space-y-4 transform transition-transform duration-300 ease-in-out
          md:relative md:translate-x-0 ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} md:block`}
      >
        <h1 className="text-3xl font-extrabold tracking-tight mb-6">Vela</h1>
        <nav className="flex flex-col gap-1 text-sm font-medium">
          {navigationLinks.map(link => (
            <Link
              key={link.label}
              to={link.to}
              className="px-3 py-2 rounded
                       hover:bg-emerald-50 hover:text-emerald-800
                       transition-colors"
              onClick={() => setSidebarOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </aside>

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main content */}
      <main className="flex-1 p-4 sm:p-6">
        <div className="max-w-6xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
} 